import React from "react";
import { Grid } from "@mui/material";

import Heading from "./components/Heading";
import Calendar from "./components/Calendar";
import ScheduleInspectionUI from "../../components/ScheduleInspectionUI";
import DashboardMetrics from "../../components/DashboardMetrics";

function CalendarPage() {
  return (
    <>
      <ScheduleInspectionUI />
      <Heading />
      <Calendar />
        <DashboardMetrics />
    </>
  );
}

export default CalendarPage;
